import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from "./CleanWindows.module.scss";
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";

const CleanWindows = () => {
  const dispatch = useDispatch();
  const {countPanoramicWindows, countOrdinaryWindows} = useSelector(state => state.stepperInfo);

  const handleChangeCountPanoramicWindows = (e) => {
    // clear error if it exists
    const panWindowLabel = document.getElementById("pan_window");

    if (panWindowLabel) {
      const inputElement = panWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = panWindowLabel.querySelector("span");
      if (errorMessageSpan) {
        panWindowLabel?.removeChild(errorMessageSpan);
      }
    }
    const regWindowLabel = document.getElementById("reg_window");

    if (regWindowLabel) {
      const inputElement = regWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = regWindowLabel.querySelector("span");
      if (errorMessageSpan) {
        regWindowLabel?.removeChild(errorMessageSpan);
      }
    }

    const count = e.target.value;
    const regex = /^\d+$/;

    if (regex.test(count)) {
      dispatch(stepperInfoActions.setCountPanoramicWindows(count));
    } else {
      dispatch(stepperInfoActions.setCountPanoramicWindows(""));
    }
  }


  const handleChangeCountOrdinaryWindows = (e) => {
    // clear error if it exists
    const regWindowLabel = document.getElementById("reg_window");

    if (regWindowLabel) {
      const inputElement = regWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = regWindowLabel.querySelector("span");
      if (errorMessageSpan) {
        regWindowLabel?.removeChild(errorMessageSpan);
      }
    }
    const panWindowLabel = document.getElementById("pan_window");

    if (panWindowLabel) {
      const inputElement = panWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = panWindowLabel.querySelector("span");
      if (errorMessageSpan) {
        panWindowLabel?.removeChild(errorMessageSpan);
      }
    }

    const count = e.target.value;
    const regex = /^\d+$/;

    if (regex.test(count)) {
      dispatch(stepperInfoActions.setCountOrdinaryWindows(count));
    } else {
      dispatch(stepperInfoActions.setCountOrdinaryWindows(""));
    }
  }

  return (
    <div className={styles.cleanWindows}>
      {/*<p>Миття вікон <sup>*</sup></p>*/}

      <div className={styles.cleanWindows_inputsContainer}>
        <div className={styles.cleanWindows_inputsContainer_block}>
          <p>Кількість панорамних вікон</p>

          <form action="#">
            <label id={"pan_window"}>
              <input
                value={countPanoramicWindows}
                onChange={handleChangeCountPanoramicWindows}
                className={styles.input}
                type="number"
                placeholder={'Напишіть кількість'}
                min={1}
              />
            </label>
          </form>
        </div>

        <div className={styles.cleanWindows_inputsContainer_block}>
          <p>Кількість звичайних вікон</p>

          <form action="#">
            <label id={"reg_window"}>
              <input
                value={countOrdinaryWindows}
                onChange={handleChangeCountOrdinaryWindows}
                className={styles.input}
                type="number"
                placeholder={'Напишіть кількість'}
                min={1}
              />
            </label>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CleanWindows;
